import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";
import {LogadoService} from "../../../providers/logado-service";
import {DataService} from "../../../providers/data-service";
import {TAction, TImageModel} from "../../../app/enum";
import {CONFIG} from "../../../app/config";

import {HotspotService} from "../../../providers/hotspot-service";


@Component({
    selector: 'page-cashier-menu',
    templateUrl: 'cashier-menu.html',
})
export class CashierMenuPage {

    TImageModel: any = TImageModel;

    config: any;

    logado: any;

    etapa: number;

    perfil: any;
    userset: any;

    cashiers: any;
    akkjson = (window as any).handappMainInstance.appjson;

    constructor(public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public dataService: DataService,
                public logadoService: LogadoService, public hotspotService: HotspotService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.perfil = this.navParams.get('perfil');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Cashier Menu', '/cashier-menu');

        this.cashierLoad();

    }

    ionViewDidLoad() {


    }

    getTitle() {

        if (this.etapa == 0) return 'Caixas';
        if (this.etapa == 1) return '12/05';
        if (this.etapa == 9) return 'Pagamento';

    }

    cashierLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.cashier(TAction.acLoad, 0, 0, this.perfil.Profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.cashiers = data.Cashiers,
                erro => this.util.alertResult(erro)
            );

    }

    payoff(assinar: boolean) {

    }

    dismiss() {

        this.navCtrl.pop();

    }


}



// WEBPACK FOOTER //
// ./src/pages/sync/cashier-menu/cashier-menu.ts